<button type="button" [disabled]="visibleActions.length === 0" mat-icon-button [matMenuTriggerFor]="trMenu" aria-label="Actions">
	{{label}}
	<mat-icon>{{icon}}</mat-icon>
</button>
<mat-menu #trMenu="matMenu">
	<ng-container *ngFor="let action of visibleActions; key: 'label'">
		<div [matTooltip]="isFunction(action.disabledMessage) ? action.disabledMessage(entity) : action.disabledMessage">
			<ng-container *ngTemplateOutlet="action.href ? href : button; context: { action: action, entity: entity }"></ng-container>
		</div>
	</ng-container>
</mat-menu>

<ng-template #href let-action="action" let-entity="entity">
	<a [routerLink]="isFunction(action.href) ? action.href(entity) : action.href" class="menu-link">
		<ng-container *ngTemplateOutlet="button; context: { action: action, entity: entity }"></ng-container>
	</a>
</ng-template>

<ng-template #button let-action="action" let-entity="entity">
	<button mat-menu-item class="kebab-mat-menu-item" [disabled]="action.disabled && action.disabled(entity)"
		(click)="action.onClick && action.onClick(entity)"
		[attr.aria-label]="action.ariaLabel || isFunction(action.label) ? action.label(entity) : action.label">
		<mat-icon *ngIf="isFunction(action.menuIcon) ? action.menuIcon(entity) : action.menuIcon">{{ isFunction(action.menuIcon) ?
			action.menuIcon(entity) : action.menuIcon }}</mat-icon>
		{{ isFunction(action.label) ? action.label(entity) : action.label }}
		<mat-icon *ngIf="isFunction(action.disabledMessage) ? action.disabledMessage(entity) : action.disabledMessage" color="warn">info</mat-icon>
	</button>
</ng-template>